import ja from './translate/ja.json';

export const translate = (source: string) => {
    return ja[source] ?? source;
};